import { render } from "./TempScreen.vue?vue&type=template&id=25ffcf46&scoped=true"
import script from "./TempScreen.vue?vue&type=script&lang=js"
export * from "./TempScreen.vue?vue&type=script&lang=js"

import "./TempScreen.vue?vue&type=style&index=0&id=25ffcf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ffcf46"]])

export default __exports__